import { LabsCard } from "../LabsCard.tsx";
import EmailPlanForm from "../../pages/EmailPlanForm.tsx";
import { Stack, Typography } from "@mui/material";

export const EmailPlanPanel = () => {
  return (
    <Stack direction={"column"} spacing={6}>
      <LabsCard>
        <EmailPlanForm />
      </LabsCard>
      <Typography variant="caption" color={"text.secondary"}>
        By providing your email address and submitting data via this tool, you
        agree that Cascade Energy, LLC (“Cascade”) may use your data in
        compliance with our{" "}
        <a
          href="https://cascadeenergy.com/privacy-policy/"
          target="_blank"
          rel="noopener"
        >
          privacy policy
        </a>
        . Additionally, we may anonymize data you submit and aggregate it with
        information provided by other users of this tool (“Statistical Data”).
        As between you and Cascade, Cascade owns all right, title, and interest,
        including all intellectual property rights, in and to such Statistical
        Data and this tool. Cascade provides this tool as a courtesy to all
        users. Cascade does not warrant that the information returned by this
        tool in response to the data you submit (“Responses”) may be accurate,
        reliable, or applicable to your specific needs, and Cascade provides
        this tool as-is, without warranty of any kind. You use the tool at your
        own risk and you are responsible for verifying the accuracy,
        reliability, and applicability of all Responses.
      </Typography>
    </Stack>
  );
};
